"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS_LIST_SECTION = void 0;
const PRODUCTS_LIST_SECTION = exports.PRODUCTS_LIST_SECTION = 'products-list-section';